const initialState = {
    isReadingSessionSummary: false,
    sessionSummary: [],
    sessionSummaryCount: 0,

    isReadingTextCampaignSessionSummary: false,
    textCampaignSessionSummary: [],
    textCampaignSessionSummaryCount: 0
}

export default initialState;

